import { ToastOptions } from "react-toastify";
import { ISelectOptionAntd } from "types/data";

export enum UserRole {
  Admin = "admin",
  Buyer = "buyer",
  NoRole = "no_role",
  AgricultureManager = "agriculturemanager",
  Farmer = "farmer",
}

export const PAGE_DEFAULT = {
  pageSize: 10,
  firstPage: "1",
};

export const PAGE_SIZE_10 = "10";
export const PAGE_SIZE_25 = "25";
export const PAGE_SIZE_50 = "50";

export const NOT_YET_SUPPLIED_ABB = "_1";
export const NOT_YET_SUPPLIED_ABB_NAME = "Not Yet Supplied";

export const PAGE_SIZE_100 = "100";
export const PAGE_SIZE_1000 = 1000;

export const DATE_TIME_FORMAT = "DD/MM/YYYY";

export const DATE_TIME_FORMAT_2 = "YYYY-MM-DD";

export const DATE_TIME_FORMAT_HOUR = "dddd, DD MMMM YYYY [at] HH:mm";

export const UK_TIMEZONE = "Europe/London";

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export enum ReportType {
  Activity = "activity",
  Registration = "registration",
  Preference = "preference",
}

export enum NotificationTypes {
  CmsReport = "CmsReport",
  ToggleMaintenanceStatus = "ToggleMaintenanceStatus",
  AlertToLotEmailCms = "AlertToLotEmailCms",
  RefreshPbiReports = "RefreshPbiReports",
  FarmGroupCmsNotification = "FarmGroupCmsNotification",
  LoginSuccessEvent = "LoginSuccessEvent",
  FormEditingNotification = "FormEditingNotification",
  FormReviewingNotification = "FormReviewingNotification",
  BookingUpdateNotification = "BookingUpdateNotification",
  BookingArrivalNotification = "BookingArrivalNotification",
}

export enum ModeType {
  Cattle = "C",
  Sheep = "S",
}

export const modeOptions = [
  { id: "C", label: "Cattle" },
  { id: "S", label: "Sheep" },
];

export const modeSelectOptionsAntd: ISelectOptionAntd[] = [
  { value: "C", label: "Cattle" },
  { value: "S", label: "Sheep" },
];

export const commonToastOption: ToastOptions<{}> = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined as any,
  theme: "light",
};

export enum TypeSearch {
  Text = "Text",
  MultipleDropdown = "MultipleDropdown",
  DateRangeDropdown = "DateRangeDropdown",
  MultipleDropdownSearch = "MultipleDropdownSearch",
}

export const listBooleanDropDown = [
  { label: "Yes", id: "Y" },
  { label: "No", id: "N" },
];

export const listQuickRanges = [
  { label: "This week", id: "ThisWeek" },
  { label: "This month", id: "ThisMonth" },
  { label: "Last 30 days", id: "Last30Days" },
  { label: "Last 6 months", id: "Last6Months" },
  { label: "Last 5 years", id: "Last5Years" },
];

export const listQuickRangesForLoginLogs = [
  { label: "This week", id: "ThisWeek" },
  { label: "This month", id: "ThisMonth" },
  { label: "Last 30 days", id: "Last30Days" },
];

export const tabList = [
  {
    tab: "Quick Range",
    key: "QUICK_RANGE",
  },
  {
    tab: "Custom Range",
    key: "CUSTOM_RANGE",
  },
];

//#region Constants use for FarmerCreate Form
export const geogAreaList = [
  { label: "GeogAreaFake1", value: "1", id: "1" },
  { label: "GeogAreaFake2", value: "2", id: "2" },
  { label: "GeogAreaFake3", value: "3", id: "3" },
];
export const accTypeList = [
  { label: "Master", value: "Master", id: "Master" },
  { label: "Agent", value: "Agent", id: "Agent" },
  { label: "Secondary", value: "Secondary", id: "Secondary" },
];
export const herdTypeList = [
  { label: "B", id: "B" },
  { label: "D", id: "D" },
  { label: "S", id: "S" },
];
export const productTypeList = [
  { label: "CC", value: "CC", id: "CC" },
  { label: "EF", value: "EF", id: "EF" },
  { label: "GC", value: "GC", id: "GC" },
  { label: "SP", value: "SP", id: "SP" },
];
export const VATList = [
  { label: "1", value: "1", id: "1" },
  { label: "0", value: "0", id: "0" },
];
export const baseCurrencyList = [
  { label: "GBP", value: "GBP", id: "GBP" },
  { label: "Euro", value: "Euro", id: "Euro" },
];
//#endregion
export enum AntdSortOrder {
  ASC = "ascend",
  DESC = "descend",
}

export enum ApiSortOrder {
  ASC = "A",
  DESC = "D",
}

export enum TypeAction {
  CREATE = 1,
  UPDATE = 2,
  VIEW_DETAIL = 3,
  DELETE = 4,
}

export enum TypeSelection {
  SINGLE = 1,
  MULTIPLE = 2,
}

export const DEBOUNCE_TIME_DEFAULT = 888;

export enum UserPermission {
  //1.Dashboard
  Dashboard = "1",
  LivestockActivity = "1a",
  LivestockActivity_Visuals = "1a1",
  LivestockActivity_Registration = "1a2",
  LivestockActivity_Visit = "1a3",

  CMSActivity = "1b",
  CMSActivity_Visuals = "1b1",

  KillData = "1c",
  KillData_Visuals = "1c1",
  KillData_Report = "1c2",

  MarketingPreferences = "1d",
  MarketingPreferences_Visuals = "1d1",
  MarketingPreferences_Report = "1d2",

  PGAForm = "1e",
  PGAForm_Visuals = "1e1",
  PGAForm_AuditLogReport = "1e2",
  PGAForm_NonSupplyingProducers = "1e3",
  PGAForm_NoEmailProducers = "1e4",

  //2.Report
  Report = "2",
  ViewReportslist = "2a",
  CreateNewReport = "2b",
  DeleteReport = "2c",
  DownloadReport = "2d",
  ViewAllReportslist = "2e",

  //3.Alert Management
  AlertManagement = "3",
  ViewManualAlertListAlertDetails = "3a",
  CreateAlert = "3b",
  DeleteAlert = "3c",
  ViewPGAUpdatesAlerts = "3d",

  //4.Farmer Account
  FarmerAccounts = "4",
  ViewFarmerAccountslist = "4a",
  ViewLoginLogs = "4d",
  ResetPassword = "4c",

  //5.Document Hub
  DocumentHub = "5",
  ViewDocumentslist = "5a",
  UploadDocument = "5b",
  DeleteDocument = "5c",
  GetCategoriesForDocumentHub = "5d",

  // 6. User Account
  UserAccounts = "6",
  ViewUserAccountsList = "6a",
  AssignSitesAndRoles = "6b",
  AssignFoldersToUser = "6c",

  //7 Producer Documents
  ProducerDocuments = "7",
  ViewProducerDocumentsList = "7a",
  DownloadDocument = "7b",
  ProducerDocuments_DeleteDocument = "7c",
  ProducerDocuments_EditDocument = "7d",

  //8	PGA Forms
  PGAForms = "8",
  ViewSearchDownloadPGA = "8a",
  ReviewFlagViewLogsPGA = "8b",
  EditResetPGA = "8c",

  //9	My Sites & Producers
  MySitesProducers = "9",
  ViewProducerslistSearchforProducers = "9a",
  MySiteProducerResetPassword = "9b",
  AccessPortal_ViewAll = "9c",
  AccessPortal_ExceptBenchmarkingGroups = "9d",
  AccessPortal_ExceptMyDocuments = "9e",
  AccessPortal_CreateDeleteVATReport = "9f",

  //10.Carcase Information Email
  CarcaseInformationEmail = "10",
  ViewCarcaseInfoEmailslist = "10a",
  SendEmail = "10b",
  BulkSendEmails = "10c",

  //11.Email Recipients
  EmailRecipients = "11",
  ManageRecipients = "11a",

  //12.Role & Permission
  RolePermission = "12",
  ManageRoles = "12a",
  LinkedAccount = "12b",
  ViewRequestsList = "12b1",
  ReviewRequest1st = "12b2",
  ReviewRequestFinal = "12b3",
  SubmitNewRequest = "12b4",
  // ReviewRequest1stOther = "12b5",

  //13. Benchmarking Groups
  BenchmarkingGroups = "13",
  BMViewGroupslistNDetails = "13a",
  BMManageGroups = "13b",
  BMViewGroupedProducersList = "13c",
  BMViewNonGroupedProducersList = "13d",
  DeleteAll = "13e",

  //14. Bookings
  Bookings = "14",
  Bookings_View = "14a",
  Bookings_CreateEdit = "14b",
  Bookings_Delete = "14d",
  Bookings_Restore = "14e",
  Bookings_RecycleList = "14f",
  Bookings_RecycleDelete = "14g",

  //15. Data Management
  DataManagement = "15",
  FAS = "15a",
  FAS_ViewListDetail = "15a1",
  FAS_CreateEdit = "15a2",
  FAS_Delete = "15a3",
  Buyer = "15b",
  Buyer_ViewListDetail = "15b1",
  Buyer_CreateEdit = "15b2",
  Buyer_Delete = "15b3",
  Haulier = "15c",
  Haulier_ViewListDetail = "15c1",
  Haulier_CreateEdit = "15c2",
  Haulier_Delete = "15c3",
  Producer = "15d",
  Producer_ViewListDetail = "15d1",
  Producer_CreateEdit = "15d2",
  Producer_AssignHolding = "15d3",
  Producer_AddFAS = "15d4",
  Producer_AssignBuyerHaulierMatrix = "15d5",

  //16. Pricing Management
  PricingManagement = "16",
  BasePrice = "16a",
  BasePrice_View = "16a1",
  BasePrice_CreateEdit = "16a2",
  BasePrice_Copy = "16a3",
  BasePrice_Delete = "16a4",
  BasePriceAdj = "16e",
  BasePriceAdj_View = "16e1",
  BasePriceAdj_Upsert = "16e2",
  BasePriceAdj_Delete = "16e3",
  Matrix = "16b",
  Matrix_ViewListDetail = "16b1",
  Matrix_CreateEdit = "16b2",
  Matrix_Delete = "16b3",
  Charges = "16c",
  Charges_View = "16c1",
  Charges_CreateEdit = "16c2",
  Charges_Delete = "16c3",
  Bonus = "16d",
  Bonus_View = "16d1",
  Bonus_CreateEdit = "16d2",
  Bonus_Delete = "16d3",
  TransportCostPerHaulier = "16f",
  TransportCostPerHaulier_View = "16f1",
  TransportCostPerHaulier_CreateEdit = "16f2",
  TransportCostPerHaulier_Delete = "16f3",
  ManualAdjustment = '16g',
  ManualAdjustment_View = '16g1',
  ManualAdjustment_CreateEdit = '16g2',
  ManualAdjustment_Delete = '16g3',

  //17. Lot Pricing
  LotPricing = "17",
  LotPricing_View = "17a",
  // LotPricing_Edit = "17b",
  LotPricing_Price = "17b",
  LotPricing_Unprice = "17d",
  LotPricing_PricingComplete = "17e",
  LotPricing_Import = "17f",
  LotPricing_Export = "17g",
  LotPricing_Print = "17h",
  LotPricing_SplitLot = "17i",

  //18. Lot Approval
  GMApproval = "18",
  GMApproval_View = "18a",
  GMApproval_ApproveReject = "18b",

  //19. KillLine API Logs
  KillLineAPILogs = "19",
  View = "19a",

  //20. Eartag Search
  EartagSearch = "20",

  //21. Booking Features
  BookingFeatures = "21",
  BookingFeatures_View = "21a",
  BookingFeatures_CreateEdit = "21b",
  BookingFeatures_Delete = "21c",

  //22. Grounded In Goodness
  GroundedInGoodness = "22",
  ManageSchemeMembers = "22a",
}

export const AccessPortalPermissions = [
  UserPermission.AccessPortal_ViewAll,
  UserPermission.AccessPortal_ExceptMyDocuments,
  UserPermission.AccessPortal_ExceptBenchmarkingGroups,
];

export enum ResponseStatus {
  Success = 0,
  Fail = 10,
  Invalid = 20,
  Valid = 30,
  Available = 40,
  NotAvailable = 50,
  FailWithException = 60,
  InProgress = 70,
  Completed = 80,
}
